import { LitElement, html, css } from 'lit';

// import '@material/mwc-ripple';

class CostsOnsite extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
      }

      .description {
        font-weight: 500;
      }
      dl {
        padding: 0;
        margin: 0;
      }

      dt {
        color: #757575;
        font-size: 90%;
      }
      .all {
        padding-bottom: 0.5em;
      }

      dd {
        color: #455a64;
        margin: 0;
      }

      dt,
      dd,
      .all {
        break-inside: avoid;
        page-break-inside: avoid;
        -webkit-column-break-inside: avoid;
      }
      span {
        font-weight: 600;
      }
    `;
  }

  render() {
    return html`
      <div>
        <span>Bijkomende kosten</span>
        ${!this.items || !this.items.length
          ? html`
              <div class="all">
                Geen
              </div>
            `
          : html`<dl>
              ${this.items.map(item => {
                return html`
                  <div class="all">
                    <dt>${item.Description}</dt>
                    <dd>${item.Value}</dd>
                  </div>
                `;
              })}
            </dl>`}
      </div>
    `;
  }

  static get properties() {
    return {
      items: {
        type: Array,
      },
    };
  }

  static get is() {
    return 'costs-onsite';
  }
}
customElements.define(CostsOnsite.is, CostsOnsite);
